import { SocialComponents } from 'be-components';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Helmet } from 'react-helmet-async';
import { V1_SHOW_AUTHENTICATE, V1_SHOW_PROFILE } from '../../store/actionsv1/types';
import { market_setDraftOrder } from '../../store/actionsv1/markets';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { getPlayerByIdNoStore } from '../../store/actionsv1/social';
import { useSafeAreaInsets } from 'react-native-safe-area-context';



const SocialProfileScreen = ({route, navigation}:any) => {
    const [ viewing_player, setViewingPlayer ] = useState<PublicPlayerProps|undefined>(undefined);

    useEffect(() => {
        getPlayerData(route.params.player_id);
    },[route.params.player_id]);

    const getPlayerData = async(player_id:string) => {
        const p = await getPlayerByIdNoStore(player_id);
        setViewingPlayer(p);
    }

    const dispatch = useDispatch();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const bottom_tab_height = useSelector((state:any) => state.util.bottom_tab_height, (left, right) => left == right);
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.height == right.height);
    const insets = useSafeAreaInsets();

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            {viewing_player ?
            <Helmet>
                <title>{viewing_player.username}</title>
                <meta name='description' content={viewing_player.bio ?? `View the BettorEdge profile for @${viewing_player.username}`} />
                <meta name='og:image' content={viewing_player.profile_pic && viewing_player.profile_pic != '' ? viewing_player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp'} />
            </Helmet>
            :<></>}
            <SocialComponents.PlayerProfile
                maxWidth={600}
                padding_insets={insets}
                onViewPostComments={(post_id) => navigation.push('ActivityDetail', { post_id: post_id, post_type:'memo' })}
                onEditProfile={() => dispatch({ type: V1_SHOW_PROFILE, show_profile: { visible: true } })}
                height={app_size.height - bottom_tab_height - 20}
                viewing_player_id={route.params.player_id}
                player_id={player?.player_id}
                onCopyOrder={(o) => dispatch(market_setDraftOrder(o))}
                onFadeOrder={(o) => dispatch(market_setDraftOrder(o))}
                onBack={() => navigation.goBack()}
                onRequestAuthentication={() => dispatch({ type:V1_SHOW_AUTHENTICATE, show_authenticate: { visible: true, hide_close:false, nav_out:false } })}
                onSelectPlayer={(player_id) => navigation.push('SocialProfile', { player_id:player_id })}
                onStartChat={player && player.player_id != route.params.player_id ? (player_id) => navigation.push('DirectMessage', { player_id:player.player_id, other_id: player_id }) : undefined}
                onHeadToHead={player && player.player_id != route.params.player_id ? (player_id) => navigation.push('H2H', { player_id: player_id }): undefined}
            />
        </View>
    )
}

export default SocialProfileScreen